import { Icon } from '@chakra-ui/react';

export default function SFBookmarkIcon(props) {
  return (
    <Icon
      width={5}
      height={5}
      viewBox='0 0 20 20'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M6.30207 17.272C5.86588 17.272 5.61197 16.9855 5.61197 16.4777V5.17562C5.61197 3.93864 6.23046 3.30713 7.45442 3.30713H12.5456C13.7695 3.30713 14.388 3.93864 14.388 5.17562V16.4777C14.388 16.9855 14.1341 17.272 13.6979 17.272C13.3789 17.272 13.1901 17.0897 12.6042 16.5233L10.0586 14.0168C10.0325 13.9842 9.97395 13.9842 9.9414 14.0168L7.39582 16.5233C6.80989 17.0897 6.62108 17.272 6.30207 17.272ZM6.83593 15.5142L9.65494 12.7798C9.86327 12.578 10.1367 12.578 10.345 12.7798L13.1641 15.5142C13.2617 15.6053 13.3594 15.5793 13.3594 15.4491V5.18864C13.3594 4.62874 13.0664 4.33577 12.5 4.33577H7.5065C6.93358 4.33577 6.64061 4.62874 6.64061 5.18864V15.4491C6.64061 15.5793 6.74478 15.6053 6.83593 15.5142Z' />
    </Icon>
  );
}
